export const styles = {
  form: 'tw-flex tw-flex-col tw-gap-4',
  fieldGroup: 'tw-flex tw-flex-col tw-gap-1',
  label: 'tw-text-sm tw-font-medium tw-text-neutral-700',
  textarea:
    'tw-w-full tw-rounded-md tw-border tw-border-neutral-300 tw-p-2 tw-text-sm tw-font-mono tw-resize-none focus:tw-border-blue-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500',
  textareaError:
    'tw-w-full tw-rounded-md tw-border tw-border-red-400 tw-bg-red-50 tw-p-2 tw-text-sm tw-font-mono tw-resize-none focus:tw-border-red-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-red-500',
  multiSelect:
    'tw-w-full tw-rounded-md tw-border tw-border-neutral-300 tw-p-1 tw-text-sm focus:tw-border-blue-500 focus:tw-outline-none',
  hint: 'tw-text-xs tw-text-neutral-500',
  errorHint: 'tw-text-xs tw-text-red-500',
  footer: 'tw-flex tw-justify-end tw-gap-2',
};
